import * as Path from "../routes/routesPath";

export const skeletonBaseColor = "#d3d3d3";
export const skeletonHighlightColor = "#e0e0e0";

export const passwordregex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export const maleAvatarHolder = "/images/userImage.webp";
export const femaleAvatarHolder = "/images/userImage-girl.webp";

export const genderOptions = [
  { value: "male", label: "He/Him/His" },
  { value: "female", label: "She/Her/Hers" },
  { value: "other", label: "Ze/Zir/Zirs" },
];

export const userReportReasons = [
  { value: "nudityOrSexualActivity", label: "Nudity or sexual activity" },
  { value: "hateSpeech", label: "Hate speech" },
  { value: "scamOrFraud", label: "Scam or fraud" },
  { value: "bullyingOrHarassment", label: "Bullying or harassment" },
  { value: "saleOfIllegalProducts", label: "Sale of illegal products" },
  { value: "violenceOrDanger", label: "Violence or danger" },
  { value: "spam", label: "Spam" },
];

export const storyReportReasons = [
  { value: "abusive", label: "Abusive" },
  { value: "askForMoney", label: "Ask for money" },
  { value: "violence", label: "Violence" },
  { value: "hateSpeech", label: "Hate speech" },
  { value: "falseInformation", label: "False information" },
];

export const sortingOptions = [
  { value: "relevance", label: "Relevance", orderBy: "_id", order: -1 },
  { value: "latestFirst", label: "Latest first", orderBy: "updatedAt", order: -1 },
  { value: "oldestFirst", label: "Oldest first", orderBy: "updatedAt", order: 1 },
];

export const defaultPage = {
  orderBy: "_id",
  order: -1,
  page: 1,
  limit: 30,
};

export const limitOptions = [
  { value: 20, label: 20 },
  { value: 50, label: 50 },
  { value: 75, label: 75 },
  { value: 100, label: 100 },
];

export const contactUsReason = [
  { value: "suggestionOrFeedback", label: "Suggestion or Feedback" },
  { value: "problemOrComplaint", label: "Problem or Complaint" },
  {
    value: "reportIllegalOrInappropriateContent",
    label: "Report illegal or Inappropriate content",
  },
];

export const socialHandles = {
  instagram: "https://www.instagram.com/feelinghub_official?igsh=MWQ3cmY3eHd2c3UxcA==",
  facebook: "https://www.facebook.com/profile.php?id=61570553554652&mibextid=ZbWKwL",
  youtube: "https://youtube.com/@feelinghub_official?si=CTYX1S12sYnAC-6u",
  telegram: "#",
  whatsapp: "https://whatsapp.com/channel/0029Vb0XaPj7z4kkSZ2Rqi2I",
  twitter: "https://x.com/feelinghub_01",
};

// SEO data
export const defaultDescription =
  "Feelinghub is a safe space to share your emotions, confessions, and life stories anonymously. Comment, react, and connect through end-to-end encrypted chats.";

export const mainKeywords = [
  "share feelings online", // Primary keyword
  "Confession sharing app",
  "Share emotions safely and securely",

  "Anonymous feelings sharing platform",
  "Emotional support community",
  "Post life stories anonymously",
  "Anonymous social platform",
];
// "Chat anonymously online",
// "Read and react to life stories",
// "Share love, anger, confessions",
// "Online diary for feelings",
// "Comment and react to stories",
// "Connect through emotions",
// "Share feelings anonymously without judgment",

export const routeMetadata = {
  "/": {
    title: "Share your feelings online",
    description:
      "Share Stories, Express Feelings, Ask Questions, Find Answers, Explore Interests, Make Friends, Express your true Self - The New Experience Project is Here!",
    // "Feelinghub is a anonymous feelings sharing platform. Share feelings online, post life stories and connect with community through encrypted chats.",
    keywords: ["real-life stories"],
  },
  [Path.homeRoute]: {
    title: "Share your feelings online",
    description:
      "Share Stories, Express Feelings, Ask Questions, Find Answers, Explore Interests, Make Friends, Express your true Self - The New Experience Project is Here!",
    // "Feelinghub is a anonymous feelings sharing platform. Share feelings online, post life stories and connect with community through encrypted chats.",
    keywords: ["real-life stories"],
  },
  [Path.addStoryRoute]: {
    title: "Share your feelings",
    keywords: [
      "Online diary",
      "Share love, anger, confessions",
      "Share feelings anonymously without judgment",
      "How You're Feeling today",
    ],
    description:
      "Feelinghub allows you to share feelings online or post life stories anonymously where no can judge you. It is a safe space to express yourself.",
    link: Path.addStoryRoute,
  },
  [Path.signinRoute]: {
    title: "Join to connect with emotional support community",
    description:
      "Feelinghub is an anonymous social platform to share feelings online or post life stories anonymously for free. It is a safe space to express yourself.",
    link: Path.signinRoute,
  },
  [Path.signupRoute]: {
    title: "Join to connect with emotional support community",
    description:
      "Feelinghub is an anonymous social platform to share feelings online or post life stories anonymously for free. It is a safe space to express yourself.",
    link: Path.signupRoute,
  },
  [Path.privateRoutes.chatRoute]: {
    title: "Send message to the person you like",
    description:
      "Sometimes it's hard to share your feelings, Other times we  just need someone who listens us. FeelingHub is a community that understands you.",
    link: Path.privateRoutes.chatRoute,
    keywords: ["Chat anonymously online"],
  },
  [Path.contactUsRoute]: {
    title: "Contact us to share your feedback",
    description:
      "FeelingHub is always there to help and listen to you. Contact us to share your feedback, suggestion or complaints.",
    link: Path.contactUsRoute,
  },
  [Path.privateRoutes.bookmarkedStoriesRoute]: {
    title: "Save the story that you like",
    link: Path.privateRoutes.bookmarkedStoriesRoute,
  },
  [Path.privateRoutes.privateDirectoryRoute]: {
    title: "Private directory",
    link: Path.privateRoutes.privateDirectoryRoute,
  },
  [Path.storiesRoute]: {
    title: "Read what others are feeling",
    keywords: ["Read life stories", "real-life stories", "relationship advice"],
    description:
      "FeelingHub is a platform to share feelings online, read confessions, life stories and problems of others. Share your thoughts on their experiences and connect!",
    link: Path.storiesRoute,
  },
};

export const serverDataKeys = {
  storyDetails: "storyDetails",
  userProfile: "userProfile",
  homePage: "homePage",
};
